import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DecentralierService } from '@features/auth/core/auth-action/decentralization.services';
import { map, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { URI_APIs } from '@features/auth/const';
import { CoreAuthConfigService } from '@features/auth/core-auth-config.service';
import { StorageHelper } from '@features/auth/shared/helpers/storage.helper';
import {
  ILoginResponse,
} from '../login/dto/login-response.interface';
import { AuthErrorModel } from '../login/models/version-2/auth-error-version2.model';
import { AuthModelSSO } from './models/auth-sso.model';

@Injectable()
export class AuthSSOService {
  private readonly httpClient = inject(HttpClient);
  private readonly detranalizerService = inject(DecentralierService);
  private readonly conf = inject(CoreAuthConfigService);

  authEvent: Subject<any> = new Subject<any>();
  authEvent$: Observable<any> = this.authEvent.asObservable();

  private authModel!: AuthModelSSO;

  constructor() {
    this.authModel = new AuthModelSSO();
  }
  resetAppKey(typeAccount: string): void {
    if (typeAccount) {
      StorageHelper.setAppKey(typeAccount);
    } else {
      StorageHelper.setAppKey(this.conf.applicationConfig.appKey ?? '');
    }
  }

  /**
   * Set access token and authorization code to storage
   * @param username
   * @param password
   * @param typeAccount
   * @returns
   */
  login(
    username: string,
    password: string,
    typeAccount: string,
    client_id: string,
    redirectUri: string
  ): Observable<AuthModelSSO | any> {
    if (username?.trim().length == 0 || password.trim().length == 0) {
      throw new Error(`Username and password should not be empty`);
    }
    // StorageHelper.setSSOWebRedirecURI('test-redirect-uri');
    // return of(true)
    // Khong can reset app key - vi page login sso khong dung app key tu form.
    // this.resetAppKey(typeAccount);
    const url = this.conf.buildURL(URI_APIs.SSO_LOGIN);

    const requestBody: any = {
      username: username,
      password: password,
      client_id: client_id,
      redirect_uri: redirectUri
    };
    const response = this.httpClient.post<any>(url, requestBody,);

    return response.pipe(
      catchError((err) => {
        this.countLoginError();
        this.authEvent.next({ key: 'LOGIN_ERROR', value: err });
        return throwError(() => AuthErrorModel.handle(err));
      }),
      map((response: any) => {
        return this.authModel.mapDataFromAPI(response);
      }),
      tap((response) => {
        this.authEvent.next({ key: 'LOGIN', value: response });
        StorageHelper.setSSOWebAuthorizationCode(response.authorization_code ?? '');
        StorageHelper.setSSOWebRedirecURI(response.redirect_uri ?? '');
        StorageHelper.setAccessToken(response.accessToken ?? '');
      })
    );
  }

  checkValidToken(token: string) {
    if (token?.length == 0) {
      throw new Error(`Token should not be empty!`);
    }
  }

  clearLocalStorageItem = () => {
    StorageHelper.emptySessionAndLocalStorage();
    this.detranalizerService.setElements([]); // <--- Clear active element in state;
  };

  countLoginError() {
    let countLoginError = +this.getLoginCountError();
    if (countLoginError) {
      countLoginError += 1;
    } else {
      countLoginError = 1;
    }
    StorageHelper.storeLoginCountError(countLoginError);
    return countLoginError;
  }

  getLoginCountError() {
    return +StorageHelper.getLoginCountError();
  }

  clearLoginCountError() {
    StorageHelper.storeLoginCountError(0);
  }

  isLoggedIn = (): boolean => {
    // return new JWTHelpler().idValid(this.getAccessToken());
    const token = this.getAccessToken();
    return token !== undefined && token?.length !== 0;
  };

  getAccessToken = () => {
    return StorageHelper.getAccessToken();
  };

  buildTokenByJWTPrefix = (type: string = 'JWT') => {
    return `${type} ${this.getAccessToken()}`;
  };

  register(info: any): Observable<any> {
    return of(false);
  }
}
